import { CONFIGURED_TOOLTIP_TEMPLATE } from '@thoughtspot/formatter-service';
import { create } from '@thoughtspot/logger';
import { assign } from '@thoughtspot/string-util';
import _ from 'lodash';
import numeral from 'numeral';
import { getTranslatedTextCallback } from '../../../env';
const logger = create('pareto-chart');
export const PARETO_ID = 'pareto';
export function ParetoChart(H) {
    function formatPercentage(value, roundToInt) {
        return numeral(value).format(roundToInt ? '0%' : '0.00%');
    }
    function getCumulatedData(originalData) {
        let ySum = 0;
        let hasNegativeValue = false;
        let cumulativeSum = 0;
        for (let i = 0; i < originalData.length; i++) {
            const yVal = originalData[i].y;
            if (yVal < 0) {
                logger.error('invalid y value, pareto chart does not support negative values', yVal);
                hasNegativeValue = true;
                break;
            }
            ySum += yVal;
        }
        if (!hasNegativeValue && ySum > 0) {
            return originalData.map(dataPoint => {
                const newPoint = _.cloneDeep(dataPoint);
                cumulativeSum += dataPoint.y;
                newPoint.y = cumulativeSum / ySum;
                return newPoint;
            });
        }
        return null;
    }
    function getParetoAxisName(originalSeries) {
        let axisName = getTranslatedTextCallback()('cumulativePercent');
        if (originalSeries.name) {
            axisName = `${axisName} ${originalSeries.name}`;
        }
        return axisName;
    }
    H.wrap(H.Chart.prototype, 'init', function (proceed, userOptions) {
        if (!Array.isArray(userOptions.yAxis)) {
            userOptions.yAxis = [userOptions.yAxis];
        }
        userOptions.yAxis = userOptions.yAxis.filter(axis => axis.blinkType !== PARETO_ID);
        userOptions.series = userOptions.series.filter(axis => axis.blinkType !== PARETO_ID);
        if (userOptions.chart.type !== PARETO_ID) {
            return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
        }
        userOptions.chart.alignTicks = false;
        const newSeries = [];
        const newYAxes = [];
        userOptions.series.forEach((serie, seriesIndex) => {
            serie.type = 'column';
            if (serie.zIndex === undefined) {
                serie.zIndex = seriesIndex;
            }
            if (serie.id === undefined) {
                serie.id = `${seriesIndex}`;
            }
            const total = serie.data.reduce((previousValue, currentValue) => previousValue + currentValue.y, 0);
            const tickPositions = [];
            const delta = total / 5;
            for (let i = 0; i <= 5; i++) {
                tickPositions[i] = i * delta;
            }
            userOptions.yAxis[seriesIndex].tickPositions = tickPositions;
            const cumulatedData = getCumulatedData(serie.data);
            if (!cumulatedData) {
                return;
            }
            const yAxis = {
                blinkType: PARETO_ID,
                gridLineColor: 'transparent',
                opposite: true,
                min: 0,
                max: 1,
                title: {
                    text: getParetoAxisName(serie),
                },
                labels: {
                    formatter() {
                        return formatPercentage(this.value, true);
                    },
                },
            };
            newYAxes.push(yAxis);
            newSeries.push({
                type: 'line',
                blinkType: PARETO_ID,
                dataLabels: {
                    formatter() {
                        return formatPercentage(this.y, false);
                    },
                    y: -3,
                    x: -6,
                },
                color: userOptions.paretoColor,
                blinkSeriesId: PARETO_ID,
                valueColumnIdentifier: userOptions.series[0].valueColumnIdentifier,
                name: PARETO_ID,
                id: PARETO_ID,
                linkedTo: serie.id,
                zIndex: serie.zIndex + 1,
                yAxis: userOptions.yAxis.length + newYAxes.length - 1,
                data: cumulatedData,
                marker: {
                    enabled: true,
                    radius: 1,
                },
                tooltipFormatter(y) {
                    const formattedPercentage = formatPercentage(y, false);
                    return assign(CONFIGURED_TOOLTIP_TEMPLATE, formattedPercentage);
                },
            });
        });
        userOptions.yAxis.push(...newYAxes);
        userOptions.series.push(...newSeries);
        return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    });
    H.wrap(H.Chart.prototype, 'redraw', function (proceed) {
        if (this.userOptions.chart.type === PARETO_ID) {
            const addedSeries = this.series[1];
            if (addedSeries) {
                if (this.series[0].options.dataLabels.enabled) {
                    addedSeries.userOptions.dataLabels.enabled = true;
                    addedSeries.options.dataLabels.enabled = true;
                }
                else {
                    delete addedSeries.userOptions.dataLabels.enabled;
                }
            }
        }
        return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    });
}
//# sourceMappingURL=pareto-chart.js.map